import { useStore } from 'effector-react'
import * as React from 'react'
import { useLocation } from 'react-router-dom'

import { $withdrawal, withdrawalMounted } from './model'

export const useWithdrawal = () => {
  const { pathname } = useLocation()
  const withdrawal = useStore($withdrawal)

  React.useEffect(() => {
    withdrawalMounted()
  }, [pathname])

  return withdrawal
}
